import { Component, OnInit } from '@angular/core';
import {AdoptionService} from '../../services/adoption.service';
import {ActivatedRoute, Router} from '@angular/router';
@Component({
  selector: 'app-pendingupdation',
  templateUrl: './pendingupdation.component.html',
  styleUrls: ['./pendingupdation.component.css']
})
export class PendingupdationComponent implements OnInit {
  uploadingflag = 0;
  postid: any;
  AdoptionDocument = [];
  filename: any;
  loading = false;
  doctype: any;
  otpconfirm: any;
  constructor(private route: ActivatedRoute , private adoptionService: AdoptionService) {
    window.scrollTo(0, 0);
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.postid = id;
    })
  }

  ngOnInit() {
  }

  uploadFile: any;
  hasBaseDropZoneOver: boolean = false;
  options: Object = {
    url: 'https://passport.petcart.in/images/adoption/index.php'
  };
  sizeLimit = 2000000; 

  addDocument() {
    this.uploadingflag = 1;
  }
  CancelUpload() {
    this.uploadingflag = 0;
  }
  handleUploaddoc(data): void {
    if (data && data.response) {
      data = JSON.parse(data.response);
      this.uploadFile = data;
      this.filename = data.originalName;
    }
  }
beforeUploaddoc(uploadingFile): void {
    if (uploadingFile.size > this.sizeLimit) {
      uploadingFile.setAbort();
      alert('File is too large');
    }
  }
  setAdoptionDocumentpath() {
    this.loading = true;
    this.adoptionService.setAdoptionDocumentPath(this.postid, this.doctype, this.filename)
    .subscribe(
      (x) => {
        this.AdoptionDocument.push(x);
        this.doctype = undefined;
        this.filename = undefined;
        this.uploadFile = undefined;
        this.uploadingflag = 2;
        this.loading = false;
      }
    )
  }
  showFinalmessage() {
    this.uploadingflag = undefined;
    this.otpconfirm = 4;
  }
}
